<template>
    <div v-if="row.item.flags_count > 0" class="detailsButton clickable" @click.stop="callback(row)">
        <div class="row justify-content-center align-items-middle">
            <div class="col col-12">
                <div class="badge rounded-pill bg-danger">{{ row.item.flags_count }}</div>
            </div>
            <div class="col col-12 text-center">
                <AnimatedCaret :expanded="row.item.showDetailRow" />
            </div>
        </div>
    </div>
</template>

<script>
import AnimatedCaret from "@/components/AnimatedCaret.vue";

export default {
    props: {
        row: { type: Object, required: true },
        callback: { type: Function, required: true },
    },
    components: { AnimatedCaret },
};
</script>

<style lang="scss">
</style>
